import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    flos_address_field: {
        '& > div': {
            '& > div': {
                '& > .dawa-autocomplete-suggestions': {
                    margin: '1em 0 0 0',
                    padding: 0,
                    textAlign: 'left',
                    borderRadius: '0.3125em',
                    background: '#fcfcfc',
                    boxShadow: '0 0.0625em 0.15625em rgba(0, 0, 0, 0.15)',
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    overflowY: 'auto',
                    boxSizing: 'border-box',
                    fontFamily: 'Interstate, sans-serif, Arial',
                    fontWeight: 300,
                    zIndex: 10,
                    maxHeight: '80vh',
                    '& .dawa-autocomplete-suggestion': {
                        margin: 0,
                        listStyle: 'none',
                        cursor: 'pointer',
                        padding: '0.4em 0.6em',
                        color: '#333',
                        border: 'none',
                        borderBottomWidth: 0,
                        '&:first-child': {
                            borderTopLeftRadius: 'inherit',
                            borderTopRightRadius: 'inherit',
                        },
                        '&::last-child': {
                            borderBottomLeftRadius: 'inherit',
                            borderBottomRightRadius: 'inherit',
                            borderBottomWidth: '0.0625em',
                        },
                        '&:hover': {
                            background: '#f0f0f0',
                        },
                        '&.dawa-selected': {
                            background: '#f0f0f0',
                        },
                    },
                },
            },
        },
    },
}));
